<div class="card-header p-1 border-adriatic"
  [ngClass]="{strategy: projectInfo.recordType === 'Strategy', project: projectInfo.recordType === 'Project' }">
  <div>
    <span class="text-success-800 font-weight-bold">{{recordTypeName}}</span><span
  class="text-muted ml-1">({{statusName}})</span>
</div>

<h4 class="hub-project-title mb-0">
  <a [routerLink]="'/portfolio/' + hubRecordId" class="font-weight-bold">{{projectInfo?.name}}</a>
</h4>

</div>

@if (showCardDetails) {
  <div class="card-body m-1 p-1">
    <div class="description">
      <p class="record-description" [innerHTML]="projectInfo?.description"></p>
    </div>
    @if (!projectInfo?.description) {
      <p class="text-muted record-description">This record does not have a description.
      </p>
    }
    <hr>
      <div style="margin-top: 20px;">
        @if (projectInfo?.lead) {
          <span>
            Led by
            <a [routerLink]="'/user/' + projectInfo.lead?.userId" class="led-by-link">
              {{projectInfo?.lead?.name}}
            </a>
          </span>
        }
      </div>
      <div>
        @if (projectInfo.leadBusinessUnit) {
          <span>
            Managed by {{projectInfo.leadBusinessUnit}}
          </span>
        }
      </div>
      @if ((projectInfo.recordType === 'Strategy') && projectInfo.relations?.length > 0) {
        <div class="supported-by-label"
          >
          Supported by
          {{projectInfo?.relations.length}} {{projectInfo?.relations.length === 1 ? 'Project' : 'Projects'}}:
        </div>
      }
      @if ((projectInfo.recordType === 'Project') && projectInfo.relations?.length > 0) {
        <div class="supported-by-label">
          Supporting
          {{projectInfo?.relations.length}} {{projectInfo?.relations.length === 1 ? 'Strategy' : 'Strategies'}}:
        </div>
      }
      @if ((projectInfo.recordType === 'Strategy' || projectInfo.recordType === 'Project') && projectInfo.relations?.length > 0) {
        <div
          class="hub-custom-scrollbar" style="max-height: 200px; overflow-y: visible; overflow-x: hidden;">
          @for (project of projectInfo?.relations; track project.hubId) {
            <a [routerLink]="'/portfolio/' + project.hubId"
            class="badge badge-primary mr-1 mb-1">{{project.name}}</a>
          }
        </div>
      }
    </div>
  }

  <div class="goals-panel">
    @for (goal of getGoals(); track goal) {
      <div class="goal-icon {{'goal-background-' + goal.goal2030Id}}"
      [matTooltip]="goal.theme" [matTooltipShowDelay]="500" [matTooltipHideDelay]="200"></div>
    }
  </div>

  <div class="card-footer d-flex justify-content-between align-items-center p-1">
    <div>
      <div class="card-footer-buttons">
        <a href="#" (click)="toggleFavorite(hubRecordId, $event)" class="list-inline-item text-primary">
          @if (userDataService.isFavorite(hubRecordId)) {
            <span class="material-icons-outlined">favorite</span>
          }
          @if (!userDataService.isFavorite(hubRecordId)) {
            <span
            class="material-icons-outlined">favorite_border</span>
          }
        </a>

        @if (isUserCanEdit) {
          <a [routerLink]="'/portfolio/' + hubRecordId + '/edit'"
            class="list-inline-item text-primary">
            <span class="material-icons-outlined">edit</span>
          </a>
        }

        <app-add-project-to-collection-button [projectId]="projectInfo.objectID"
        [projectName]="projectInfo.name"></app-add-project-to-collection-button>

        @if (userIsCreator) {
          <a href="#" class="list-inline-item"
            (click)="deleteRecordCollectionProjectClicked()"><i class="icon-trash"></i></a>
          }
        </div>
        <span class="text-muted font-size-sm ml-3">
          Updated {{ getDistanceInWordsToNow() }}
        </span>
      </div>
    </div>
